import { isRelative } from '../../../../parser/src/utils/url';

/**
 * Normalises a base url string to make it compatible with PageJS
 * @param url URL string to normalise
 * @returns A normalised version of the url
 */
export const normaliseBaseUrl = (url: string): string => url.replace(/\/$/, '').replace('file://', '');

/**
 * Normalises a route url string to make it compatible with PageJS
 * @param url URL string to normalise
 * @returns A normalised version of the url
 */
export const normaliseRouteUrl = (url: string): string => url.replace(/^(\.?\/)?/, '/');

/**
 * Extract last hash from a url
 * @param url url to extract
 * @returns {void}
 */
export const extractLastHash = (url: string): string => {
  const regex = /#([^/#]+)(?:\/|#)?$/;
  const matches = regex.exec(url);
  return matches ? matches[1] : '';
};

/**
 * Remove last hash from a url
 * @param url url to modify
 * @returns {string} modified url
 */
export const removeLastHash = (url: string): string => {
  const lastHash = extractLastHash(url);
  if (lastHash) {
    return url.replace(`#${lastHash}`, '');
  }
  return url;
};

/**
 * Convert relative path url to hash url
 * @param url url to modify
 * @returns {string} modified url
 */
export const convertToHashUrl = (url: string): string => {
  return isRelative(url) ? `#${url.replace('.', '')}` : url;
};
